import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36')
];

export const server_loads = [];

export const dictionary = {
		"/": [15],
		"/(authenticated)/admin": [16,[2,3]],
		"/(authenticated)/admin/[slug]": [17,[2,3,4]],
		"/(authenticated)/admin/[slug]/[id]/[[tab]]": [18,[2,3,4,5]],
		"/(authenticated)/dashboard": [19,[2]],
		"/(authenticated)/datasources/[[tab]]": [20,[2]],
		"/(authenticated)/demo": [21,[2,6]],
		"/(authenticated)/demo/[org]/[id]": [22,[2,6]],
		"/(authenticated)/experimental": [23,[2,7]],
		"/(authenticated)/experimental/hewsync": [24,[2,7,8]],
		"/(authenticated)/organizations": [25,[2,9]],
		"/(authenticated)/organizations/[organization]/[[tab]]/project/[id]": [27,[2,9,10]],
		"/(authenticated)/organizations/[organization]/[[tab]]/project/[id]/[...page]": [28,[2,9,10]],
		"/(authenticated)/organizations/[organization]/[[tab]]": [26,[2,9,10]],
		"/(authenticated)/packages": [29,[2,11]],
		"/(authenticated)/packages/[id]": [30,[2,11,12]],
		"/(authenticated)/permissions": [31,[2,13]],
		"/(authenticated)/projects": [32,[2,14]],
		"/(authenticated)/projects/[slug]": [33,[2,14]],
		"/(authenticated)/projects/[slug]/[organization]/[id]": [34,[2,14]],
		"/(authenticated)/users": [35,[2]],
		"/(authenticated)/users/[id]/[[tab]]": [36,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';